import React from 'react';

export const getBadgeColor = (style: string): string => {
    switch (style) {
        case "savings": return "#16a34a"; // Green
        case "bundle": return "#ea580c";  // Orange
        case "loyalty": return "#7c3aed"; // Purple
        case "withloyaltycardonly": return "#0d9488"; // Teal
        case "new": return "#dc2626";     // Red
        case "popular": return "#475569"; // Slate
        case "limited": return "#facc15"; // Yellow
        default: return "#d9d9d9";        // Default Gray
    }
};

export const getBadgeColorName = (style: string): string => {
    switch (style) {
        case "savings": return "Green";
        case "bundle": return "Orange";
        case "loyalty": return "Purple";
        case "withloyaltycardonly": return "Teal";
        case "new": return "Red";
        case "popular": return "Slate";
        case "limited": return "Yellow";
        default: return "None";
    }
};

export const renderBadgeSwatch = (style: string) => {
    const color = getBadgeColor(style);
    return (
        <span
            style={{
                display: "inline-block",
                width: 14,
                height: 14,
                borderRadius: 4,
                backgroundColor: color,
                marginRight: 8,
                verticalAlign: "middle"
            }}
        />
    );
};
